import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {StateService} from '../../state/state.service';

@Component({
  selector: 'app-button-shipment-view',

  templateUrl: './button-shipment-view.component.html',
  styleUrls: ['./button-shipment-view.component.scss'],
})
export class ButtonShipmentViewComponent {
  @Input() rowData: any;

  constructor(private router: Router,
              private state: StateService) {}

  goToShipmentView() {
    const activeOrderId = this.rowData.id;
    const userTypePath = this.state.snapshot.auth.userPath;
    this.router.navigate([userTypePath, 'shipment', activeOrderId] );
  }
}




// WEBPACK FOOTER //
// ./src/app/shipment-in-progress/button-shipment-view/button-shipment-view.component.ts